import Screen from "@/constants/screens";
import Image from "next/image";
import { ReactElement } from "react";
import Head from "next/head";
import { useWindowSize } from "@/shared/hooks/useWindowSize";
import { MainLayout } from "@/containers/layout/LandingLayout";
import Hero from "@/components/neighbourhoods/Hero";
import Banner1 from "@/components/properties/Banner1";
import Neighbourhood from "@/components/properties/Neighbourhood";
import FlatsAndHousesToRent from "@/components/landing-new/FlatsAndHousesToRent";
import GotQuestionsAboutNeighbourhood from "@/components/properties/GotQuestionsAboutNeighbourhood";

const Southall = () => {
  const { width } = useWindowSize();
  return (
    <>
      <Head>
        <title>Rent to Own in Southall | Keyzy Homes</title>
        <link rel="canonical" href="https://www.keyzy.com/neighbourhoods/southall" />
        <meta
          name="description" key="description"
          content="Discover rent-to-own homes in Southall with Keyzy. Our innovative rent-to-buy solution helps you step onto the property ladder in this vibrant West London location known for its rich cultural heritage."
        />
        <meta
          name="twitter:card"
          content="Find your dream home in Southall with Keyzy's rent-to-own properties. Start your journey to homeownership today in this culturally diverse and well-connected London area."
          key="twcard"
        />
        <meta name="twitter:creator" content="keyzyhomes" key="twhandle" />
        <meta property="og:url" content="/neighbourhoods/southall" key="ogurl" />
        <meta property="og:image" content="/about/keyzy-meta-about.png" key="ogimage" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="Rent-to-own homes in Southall with Keyzy" />
        <meta property="og:site_name" content="Keyzy" key="ogsitename" />
        <meta property="og:title" content="Rent to Own in Southall | Keyzy Homes" key="ogtitle" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta
          property="og:description"
          content="Discover rent-to-own homes in Southall with Keyzy. Our innovative rent-to-buy solution helps you step onto the property ladder in this vibrant West London location known for its rich cultural heritage."
          key="ogdesc"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://keyzy.com/" },
                { "@type": "ListItem", "position": 2, "name": "Neighbourhoods", "item": "https://keyzy.com/neighbourhoods" },
                { "@type": "ListItem", "position": 3, "name": "Southall", "item": "https://keyzy.com/neighbourhoods/southall" },
              ],
            }),
          }}
        />
      </Head>

      <Hero neighbourhood={"Southall"} />

      <Banner1 />
      <Neighbourhood neighbourhood={"southall"} />

      <FlatsAndHousesToRent neighbourhood={"southall"} neighbourhoodName={"Southall"} />
      <section className="px-4 mt-20 bg-white overflow-hidden md:mx-6 lg:px-0 h-6 relative">
        <Image
          src={`/landing/${width < Screen.Tablet_768 ? "mobile-doodle.svg" : "tablet-doodle.svg"}`}
          alt="doodle"
          layout="fill"
          objectFit="contain"
        />
      </section>
      <GotQuestionsAboutNeighbourhood neighbourhood={"Southall"} />
    </>
  );
};

Southall.getLayout = function getLayout(page: ReactElement) {
  return <MainLayout>{page}</MainLayout>;
};

export default Southall;
